/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import StatusTable from '../StatusTable'

export default () => {
  const tableData = (item, tableHeadings) => {
    let tempData = []
    tableHeadings && tableHeadings.map((val) => tempData.push({ value: item[val] }))
    return tempData
  }

  return <StatusTable tableData={tableData} module="TARGET" />
}
